export enum ErrorMessage {
  NoDoctors = 'NoDoctors',
  NoAddresses = 'NoAddresses',
  NoServices = 'NoServices',
  NoBookingSlots = 'NoBookingSlots',
}
